import React, { useEffect, useState } from 'react';
// import Link from 'next/link';
import NftCard from '../Card/NftCard';
// import NftCardskeleton from "../skeletons/nftcard";
import { collection, getDocs, query, where } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { skeleTonJson } from '../common/jsonDumb';
import moment from 'moment';

export default function OtherNftsContainer(props) {
  const [nftDataArr, setnftDataArr] = useState([]);
  const [loadingNfts, setloadingNfts] = useState(true);

  useEffect(() => {
    getMarketPlaceData();
  }, []);

  const getMarketPlaceData = async () => {
    const mainNftArtistID = props.data.artistId;

    setloadingNfts(true);

    let dataRef = await getDocs(
      query(
        collection(firebaseFireStore, 'musicartNfts'),
        where('activeInMarketPlace', '==', true),
        where('adminState', '==', 'ACCEPT'),
        where('artistId', '==', mainNftArtistID),
      ),
    );

    if (dataRef.empty) {
      setnftDataArr([]);
      setloadingNfts(false);

      return;
    }
    let dataArr = [];

    dataRef.forEach((doc) => {
      let cObj = doc.data();
      if (cObj.tokenId !== props.data.tokenId) {
        if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
          let startingPrice = 0;
          Object.values(cObj.multipleNftDetails)
            .filter((x) => x.activeInMarketPlace)
            .map((ele, index) => {
              if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
                if (
                  ele.nftSaleType &&
                  ele.nftSaleType !== 'Auctioning' &&
                  ele.price &&
                  (!startingPrice ||
                    (startingPrice && Number(ele.price) < startingPrice))
                ) {
                  startingPrice = Number(ele.price);
                } else if (
                  ele.nftSaleType &&
                  ele.nftSaleType === 'Auctioning' &&
                  ele.auctionEndTime &&
                  ele.minBiddingPrice &&
                  (!startingPrice ||
                    (startingPrice &&
                      Number(ele.minBiddingPrice) < startingPrice))
                ) {
                  startingPrice = Number(ele.minBiddingPrice);
                }
              }
            });
          if (startingPrice) {
            dataArr.push({ ...cObj, startingPrice: startingPrice });
          }
        } else {
          if (
            (cObj.nftSaleType &&
              cObj.nftSaleType === 'Auctioning' &&
              cObj.auctionEndTime &&
              cObj.minBiddingPrice &&
              cObj.activeInMarketPlace &&
              Number(moment().format('x')) < Number(cObj.auctionEndTime)) ||
            (cObj.nftSaleType !== 'Auctioning' && cObj.price)
          ) {
            dataArr.push(cObj);
          }
        }
      }
    });

    setnftDataArr(dataArr.slice(0, 6));
    setloadingNfts(false);
  };

  return (
    <>
      {nftDataArr && nftDataArr.length > 0 && (
        <div className="main__title main__title--page mt-20 px-4">
          <h3>Similar NFTs</h3>
        </div>
      )}
      <div className="nft-card-con mt-6 off-screens-for-main-only">
        {!loadingNfts &&
          nftDataArr.map((ele, index) => {
            if (ele.activeInMarketPlace && ele.tokenId) {
              return (
                <div
                  style={{ display: 'block' }}
                  className="turning-screens 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12 "
                >
                  <NftCard
                    nftDataArr={[...nftDataArr]}
                    setnftDataArr={setnftDataArr}
                    ele={ele}
                    index={index}
                    category={'nftDetails_other_nft_container'}
                  />
                </div>
              );
            }
          })}

        {loadingNfts &&
          skeleTonJson.slice(0, 4).map((ele, index) => (
            <div
              style={{ display: 'block' }}
              className="turning-screens 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12 "
            >
              <NftCard
                // nftDataArr={nftDataArr}
                ele={ele}
                index={index}
                // setNFTDataArr={setNFTDataArr}
              />
            </div>
          ))}
      </div>
    </>
  );
}
